class ProductCardUpdater extends HTMLElement {
  constructor() {
    super();
    this._lastHoveredSwatch = null;
    this.addEventListener('click', this.handleClick.bind(this));
    this.addEventListener('mouseover', this.handleSwatchHover.bind(this));
  }

  connectedCallback() {
    const swatchList = this.querySelector('.ProductItem__ColorSwatchList');
    if (swatchList) {
      swatchList.addEventListener('mouseleave', this.handleSwatchLeave.bind(this));
    }
  }

  handleSwatchHover(event) {
    const swatch = event.target.closest('.js-manual-swatch');
    if (!swatch || swatch === this._lastHoveredSwatch) return;
    this._lastHoveredSwatch = swatch;
    if (!swatch.classList.contains('is-active')) {
      this.applySwatchData(swatch.dataset);
    }
  }

  handleSwatchLeave() {
    this._lastHoveredSwatch = null;
    const activeSwatch = this.querySelector('.js-manual-swatch.is-active');
    if (activeSwatch) {
      this.applySwatchData(activeSwatch.dataset);
    }
  }

  handleClick(event) {
    const swatch = event.target.closest('.js-manual-swatch');
    if (!swatch) return;
    event.preventDefault();

    this.querySelectorAll('.js-manual-swatch').forEach(s => s.classList.remove('is-active'));
    swatch.classList.add('is-active');
    this._lastHoveredSwatch = null;

    this.applySwatchData(swatch.dataset);
  }

  applySwatchData(data) {
    this.updateLinks(data.productUrl);
    this.updateText('.ProductItem__Title a', data.productTitle);
    this.updateText('.ProductItem__VariantName', data.variantName);
    this.updateSoldOut(data.soldOut, data.soldOutLabel, data.productData);
    this.updateBlock('.ProductItem__PriceList', data.priceHtml);
    this.updateImage(
      '.ProductItem__Image:not(.ProductItem__Image--alternate)',
      data.mainImageUrl,
      data.mainImageWidths,
      data.mainImageAlt,
      data.mainImageMediaId
    );
    this.updateImage(
      '.ProductItem__Image--alternate',
      data.altImageUrl,
      data.altImageWidths,
      data.altImageAlt,
      data.altImageMediaId
    );
  }

  updateSoldOut(soldOut, label, productData) {
    // The SOLD OUT label is the toggled one. A COMING SOON label ([data-waitlist-coming])
    // may sit alongside it and must stay visible regardless of the swatch's stock.
    const soldOutEl = this.querySelector('.ProductItem__WaitlistLabel:not([data-waitlist-coming])');
    if (soldOutEl) {
      if (soldOut === 'true') {
        if (label) soldOutEl.textContent = label;
        // keep the Back-in-Stock trigger pointed at the selected swatch's product
        if (productData) soldOutEl.setAttribute('data-product-data', productData);
        soldOutEl.hidden = false;
      } else {
        soldOutEl.hidden = true;
      }
    }

    // COMING SOON label: never hidden or relabelled; only refresh its BIS target.
    const comingEl = this.querySelector('.ProductItem__WaitlistLabel[data-waitlist-coming]');
    if (comingEl && productData) comingEl.setAttribute('data-product-data', productData);
  }

  updateLinks(url) {
    if (!url) return;
    this.querySelectorAll('a.ProductItem__ImageWrapper, .ProductItem__Title a, .ProductItem__waitlist-cta')
      .forEach(a => {
        if (a) a.href = url;
      });
  }

  updateText(selector, newText) {
    const el = this.querySelector(selector);
    if (el && newText) {
      el.textContent = newText;
    } else if (el) {
      el.textContent = '';
    }
    console.log("update");
  }

  updateBlock(selector, newHtml) {
    const el = this.querySelector(selector);
    if (el && newHtml) {
      el.outerHTML = newHtml;
    }
  }

  updateImage(selector, url, widthsJson, alt, mediaId) {
    const img = this.querySelector(selector);
    if (!img || !url) return;

    try {
      const widths = JSON.parse(widthsJson);
      const srcset = widths
        .map(w => `${url.replace('{width}', w)} ${w}w`)
        .join(', ');

      img.src = url.replace('{width}', '400');
      img.srcset = srcset;
      img.alt = alt;
      if (mediaId) img.setAttribute('data-media-id', mediaId);

      img.classList.remove('Image--lazyLoad', 'lazyloaded');
      img.classList.add('Image--fadeIn');
    } catch (e) {
      console.error('Failed to update image:', e);
    }
  }
}

if (!customElements.get('product-card-updater')) {
  customElements.define('product-card-updater', ProductCardUpdater);
}
